import ctLocale from 'element-ui/lib/locale/lang/zh-TW'
const ct = {
  message: {
    'toLogin': '賬號登錄',
    'login': '登錄',
    'userName': '用戶名',
    'enterprise': '企業號',
    'mobilePhone': '手機號',
    'ObtAccount': 'Obt賬號',
    'password': '密碼',
    'verificationCode': '驗證碼',
    'home': '首頁',
    'ItineraryBooking': '行程預定',
    'myApplication': '我的申請',
    'myApproval': '我的審批',
    'myOrder': '我的訂單',
    'myItinerary': '我的行程',
    'dataManagement': '資料管理',
    'airTickets': '國內機票',
    'International': '國際機票',
    'hotel': '酒店預訂',
    'trainTickets': '火車票',
    'notBooking': '不可預訂',
    'pleaseEnableTrToBook': '請開啓tr預定權限',
    'cannotBeBooked': '未維護審批流數據，不可預定',
    'certificateInformation': '請維護證件信息'
  },
  'AuthenticationFailure': '身份驗證失效',
  '00000': '未知錯誤！',
  '00001': '保存失敗！',
  '00002': '保存成功！',
  '00003': '刪除成功！',
  '00004': '删除失败！',
  '10001': '用戶名衝突，請輸入企業號！',
  // 退票新增字段
  R200: "退票類型",
  R201: "退票原因",
  R202: "情況說明",
  R203: "自願退票",
  R204: "非自願退票",
  R205: "因航班變動/取消等原因",
  R206: "健康原因無法乘機",
  R207: "特殊原因無法乘機",
  R208: "其他情況",
  R209: "請選擇退票原因",
  R210: "請填寫情況說明",
  // 退票详情页展示
  R211: "退票類型",
  R212: "退票原因",
  R213: "情況說明",
  // 改签新增字段
  R214: "改簽類型",
  R215: "改簽原因",
  R216: "自願改期",
  R217: "非自願改期",
  R218: "請選擇改簽原因",
  R219: "已提交人工處理，請等待客服確認",
  R220: "提交人工處理",
  R221: "非自願改簽僅支持同艙位航班",

  // 火车票票状态
  A249: "票狀態",
  A250: "已出票",
  A251: "待出票",
  A252: "退票成功",
  A253: "改簽中",
  A254: "改簽失敗",
  A255: "改簽成功",
  A256: "退票中",
  A257: "退票失敗",

  ...ctLocale
}

export default ct



// WEBPACK FOOTER //
// ./src/i18n/langs/ct.js